import { Pipe, PipeTransform } from '@angular/core';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';

@Pipe({
  name: 'departmentHours'
})
export class DepartmentHoursPipe implements PipeTransform {
  public transform(departmentEstimate: DepartmentEstimate): number {
    let total = 0;

    for (const estimateLine of departmentEstimate.estimateLines) {
      for (const classificationLine of estimateLine.classificationLines) {
        total += classificationLine.hours;
      }
    }

    return total;
  }
}
